module.exports = __webpack_public_path__ + "img/img_highCoverage.8993af7d.png";